/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react';
import { numberToPrettyString } from '@cian/utils';
import { IProject } from '../../../types';
import { unbreakText } from '../../../utils/unbreakText';
import * as styles from './ProjectPreview.css';

export interface IProjectListItemProps {
  project: IProject;
  onClick(): void;
}

export const ProjectPreview: React.FC<IProjectListItemProps> = ({ project, onClick }) => {
  const { imageUrl, url, name, constructionType, area, priceMin, contractor } = project;

  return (
    <a href={url} className={styles['container']} target="_blank" onClick={onClick}>
      <div className={styles['image_container']}>
        <img src={imageUrl} alt={name} />
      </div>
      <div className={styles['content']}>
        <strong className={styles['title']}>{name}</strong>
        <span className={styles['text']}>{constructionType}</span>
        <span className={styles['text']}>{area}м²</span>
        <span className={styles['text']}>от {numberToPrettyString(priceMin)} &#8381;</span>
      </div>
      <div className={styles['footer']}>
        {contractor.logoUrl && (
          <div className={styles['footer_image_container']}>
            <img src={contractor.logoUrl} alt={contractor.name} />
          </div>
        )}
        <span className={styles['footer_text']}>Строитель «{unbreakText(contractor.name)}»</span>
      </div>
    </a>
  );
};
